export default __webpack_public_path__ + "static/media/close.d667a3c3.svg";